// extracted by mini-css-extract-plugin
export default {"card":"NoteCard-module__card__3CSEz","icon":"NoteCard-module__icon__e3CrH","title":"NoteCard-module__title__X426V","text":"NoteCard-module__text__G3HEW"};